<!--https://github.com/nguyenvanduocit/vue-loading-spinner/blob/master/src/components/Circle.vue-->
<template>
  <svg
    v-bind="$attrs"
    :style="{
      width: `${size}px`,
      height: `${size}px`,
      '--offset': 187,
      '--duration': `1.4s`,
    }"
    class="spinner spinner--circle"
    viewBox="0 0 66 66"
  >
    <circle
      class="path stroke-current"
      fill="none"
      stroke-width="6"
      stroke-linecap="round"
      cx="33"
      cy="33"
      r="30"
    />
  </svg>
</template>

<script setup>
defineProps({
  size: {
    type: String,
    default: '40',
  },
})
</script>

<style scoped>
.spinner {
  animation: circle-rotator var(--duration) linear infinite;
  * {
    line-height: 0;
    box-sizing: border-box;
  }
}
@keyframes circle-rotator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(270deg);
  }
}
.path {
  stroke-dasharray: var(--offset);
  stroke-dashoffset: 0;
  transform-origin: center;
  animation: circle-dash var(--duration) ease-in-out infinite;
}
@keyframes circle-dash {
  0% {
    stroke-dashoffset: var(--offset);
  }
  50% {
    stroke-dashoffset: calc(var(--offset) / 4);
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: var(--offset);
    transform: rotate(450deg);
  }
}
</style>
